
let menuItems = [
    {
        id: 1,
        label: 'Anasayfa',
        icon: 'bx-bar-chart',
        link: '/',
    },
    {
        id: 2,
        label: 'Ürün',
        icon: 'bx-box',
        link: '/stock-list',
    },
    {
        id: 3,
        label: 'Cari',
        icon: 'bx-user',
        link: '/current-list',
    },
    {
        id: 8,
        label: 'Sipariş İşlemleri',
        icon: 'bx-cart',
        subItems: [
            {
                id: 9,
                label: 'Siparişler',
                link: '/order-list',
                parentId: 8
            },
            {
                id: 10,
                label: 'B2B Siparişleri',
                link: '/b2b-order-list',
                parentId: 8
            },
            {
                id: 11,
                label: "Bekleyen Siparişler",
                link: "/pending-order-list",
                parentId: 8
            },
            {
                id: 12,
                label: "Satın Alma Siparişleri",
                link: "/purchase-order-list",
                parentId: 8
            }
        ]
    },
    {
        id: 12,
        label: 'Ödeme',
        icon: 'bx-credit-card',
        subItems: [
            {
                id: 37,
                label: 'Sanal Pos',
                link: '/payment',
                parentId: 12
            },
            {
                id: 38,
                label: 'Tahsilat',
                link: '/collection',
                parentId: 12
            },
        ]
    },
    {
        id: 16,
        label: 'Kampanya',
        icon: 'bx-bell',
        link: '/campaigns',
    },
    {
        id: 18,
        label: 'Yönetim',
        icon: 'bx-cog',
        subItems: [
            {
                id: 19,
                label: 'Kullanıcı Yönetimi',
                link: '/management/user-management',
                parentId: 18
            },
            {
                id: 21,
                label: 'Ayarlar',
                link: '/management/settings',
                parentId: 18
            },
            {
                id: 22,
                label: 'Duyurular',
                link: '/management/announcement',
                parentId: 18
            },
            {
                id: 23,
                label: 'Pos Yönetimi',
                link: '/management/payment-settings',
                parentId: 18
            },
            {
                id: 24,
                label: 'Slider Yönetimi',
                link: '/management/slider-management',
                parentId: 18
            },
            {
                id: 25,
                label: 'Ödeme Tipleri',
                link: '/management/payment-methods',
                parentId: 18
            },
            {
                id: 26,
                label: 'Sepet Kategorileri',
                link: '/management/basket-categories',
                parentId: 18
            },
            {
                id: 27,
                label: 'Stok Kategorileri',
                link: '/management/stock-categories',
                parentId: 18
            },
            {
                id: 28,
                label: 'Detaylı Raporlama',
                link: '/management/detailed-reports',
                parentId: 18
            },
            {
                id: 32,
                label: 'Hedef Yönetimi',
                link: '/management/target-management',
                parentId: 18
            },
            {
                id: 33,
                label: 'Şube & Depo Yönetimi',
                link: '/management/branch-warehouse-management',
                parentId: 18
            },
        ]
    },
    {
        id: 36,
        label: 'Projeler',
        icon: 'bx-briefcase',
        link: '/project',
    },
];
let menuItemsCustomer = [
    {
        id: 1,
        label: 'Anasayfa',
        icon: 'bx-bar-chart',
        link: '/',
    },
    {
        id: 2,
        label: 'Ürün',
        icon: 'bx-search',
        link: '/stock-list',
    },
    {
        id: 19,
        label: 'Hesabım',
        icon: 'bx-user',
        subItems: [
            {
                id: 32,
                label: 'Kapatılmamış Faturalar',
                link: '/unclosed-invoices',
                parentId: 19
            },
            {
                id: 33,
                label: 'Hesap Ekstresi',
                link: '/current-actions',
                parentId: 19
            }
        ]
    },
    {
        id: 8,
        label: 'Sipariş İşlemleri',
        icon: 'bx-cart',
        subItems: [
            {
                id: 9,
                label: 'Siparişler',
                link: '/order-list',
                parentId: 8
            },
            {
                id: 10,
                label: 'B2B Siparişleri',
                link: '/b2b-order-list',
                parentId: 8
            },
            {
                id: 11,
                label: "Bekleyen Siparişler",
                link: "/pending-order-list",
                parentId: 8
            }
        ]
    },
    {
        id: 39,
        label: 'Ödeme',
        icon: 'bx-credit-card',
        subItems: [
            {
                id: 37,
                label: 'Ödeme Durumları',
                link: '/payment',
                parentId: 39
            },
            {
                id: 38,
                label: 'Ödeme Yap',
                link: '/collection',
                parentId: 39
            },
        ]
    },
    {
        id: 16,
        label: 'Kampanya',
        icon: 'bx-bell',
        link: '/campaigns',
    },
    {
        id: 36,
        label: 'Projelerim',
        icon: 'bx-briefcase',
        link: '/project',
    },
];
let menuItemsSalesPerson = [
    {
        id: 1,
        label: 'Anasayfa',
        icon: 'bx-bar-chart',
        link: '/',
    },
    {
        id: 2,
        label: 'Ürün',
        icon: 'bx-search',
        link: '/stock-list',
    },
    {
        id: 3,
        label: 'Cari',
        icon: 'bx-user',
        link: '/current-list'
    },
    {
        id: 8,
        label: 'Sipariş İşlemleri',
        icon: 'bx-cart',
        subItems: [
            {
                id: 9,
                label: 'Siparişler',
                link: '/order-list',
                parentId: 8
            },
            {
                id: 10,
                label: 'B2B Siparişleri',
                link: '/b2b-order-list',
                parentId: 8
            },
            {
                id: 11,
                label: "Bekleyen Siparişler",
                link: "/pending-order-list",
                parentId: 8
            }
        ]
    },
    {
        id: 37,
        label: 'Ödeme',
        icon: 'bx-credit-card',
        subItems: [
            {
                id: 37,
                label: 'Ödeme Durumları',
                link: '/payment',
                parentId: 37
            },
            {
                id: 38,
                label: 'Ödeme Yap',
                link: '/collection',
                parentId: 37
            },
        ]
    },
    {
        id: 12,
        label: 'Tahsilat Yap',
        icon: 'bx-credit-card',
        link: '/collection',
    },
    {
        id: 16,
        label: 'Kampanya',
        icon: 'bx-bell',
        link: '/campaigns',
    },
    {
        id: 36,
        label: 'Projeler',
        icon: 'bx-briefcase',
        link: '/project',
    },
];
export {menuItems, menuItemsCustomer, menuItemsSalesPerson}
